// import { isValidPhoneNumber } from 'react-phone-number-input';

// @todo: optamos por simplificar a validação de telefone, checando apenas se ela tem
// um número mínimo de dígitos
export default function validatePhone(phone) {
  // if (!isValidPhoneNumber(phone)) {
  if (phone.length <= 6) {
    return 'invalid phone number';
  }
}
